import {
  Checkbox,
  Col,
  Flex,
  Form,
  FormInstance,
  Input,
  InputNumber,
  Radio
} from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const GastroIntenstinalSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasGastro =
    Form.useWatch(['form', 'symptoms', 'gastroIntestinal', 'status'], form) ===
    'yes'

  const hasVomiting = Form.useWatch(
    ['form', 'symptoms', 'gastroIntestinal', 'vomiting', 'isSelected'],
    form
  )

  const hasDiarrhea = Form.useWatch(
    ['form', 'symptoms', 'gastroIntestinal', 'diarrhea', 'isSelected'],
    form
  )

  const hasDehydration = Form.useWatch(
    ['form', 'symptoms', 'gastroIntestinal', 'dehydration', 'isSelected'],
    form
  )

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'gastroIntestinal', 'status']}
          rules={requiredRules}
          label={`6. ${t('epidemiology.gastro_intestinal')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasGastro && (
        <>
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'lossOfAppetite',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>1. Pierderea poftei de mâncare</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'nausea',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>2. Greață</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'swallowingDifficulties',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>3. Dificultăți la înghițire</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'bloodInStool',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Sânge în scaun</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'acolicStool',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>5. Scaun acolic</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'tenesmus',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>6. Tenesme</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'vomiting',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>7. Vomă</Checkbox>
            </Form.Item>
          </Col>

          {hasVomiting && (
            <Col span={8}>
              <Flex gap={8} align="center">
                <Form.Item
                  name={[
                    'form',
                    'symptoms',
                    'gastroIntestinal',
                    'vomiting',
                    'dayFrequency',
                    'value'
                  ]}
                  label="7.1 Frecvența pe zi"
                >
                  <InputNumber
                    placeholder="Frecvența pe zi"
                    min={1}
                    className="full-width"
                  />
                </Form.Item>
              </Flex>
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'diarrhea',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>8. Diaree</Checkbox>
            </Form.Item>
          </Col>

          {hasDiarrhea && (
            <Col span={8}>
              <Form.Item
                name={[
                  'form',
                  'symptoms',
                  'gastroIntestinal',
                  'diarrhea',
                  'dayFrequency',
                  'value'
                ]}
                label="8.1 Frecvența pe zi"
              >
                <InputNumber
                  placeholder="Frecvența pe zi"
                  min={1}
                  className="full-width"
                />
              </Form.Item>
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'gastroIntestinal',
                'dehydration',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>9. Deshidratare</Checkbox>
            </Form.Item>
          </Col>

          {hasDehydration && (
            <Col span={8}>
              <Form.Item
                name={[
                  'form',
                  'symptoms',
                  'gastroIntestinal',
                  'dehydration',
                  'severity',
                  'value'
                ]}
                label="9.1 Gradul"
              >
                <Input placeholder="Gradul" className="full-width" />
              </Form.Item>
            </Col>
          )}
        </>
      )}
    </>
  )
}
